import { useState } from "react";
import { useTranslation } from "react-i18next";

const Testimonials: React.FC<{}> = ({}) => {
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === "ar";

    const testimonials = [
        {
            icon: "/cargo/testimonials/pic1.png",
            title: isArabic ? "اسم العميل" : "Client Name",
            desc: isArabic
                ? "لا يُمكن الاستغناء عن الدقة والموثوقية عند الشحن — فهي أساسية. هذا سبب اختيار الشركات حول العالم لنا لنقل ما يهمهم:"
                : "Praesent non enim sed velit malesuada consectetur id a justo. Fusce quis eros sit amet enim laoreet dignissim. Sed auctor massa non arcu posuere, id sodales metus interdum.",
            stars: 5,
        },
        {
            icon: "/cargo/testimonials/pic2.png",
            title: isArabic ? "اسم العميل" : "Client Name",
            desc: isArabic
                ? "نحن ملتزمون بالتواصل السريع والشفاف لتقديم أفضل تجربة شحن ممكنة."
                : "Praesent non enim sed velit malesuada consectetur id a justo. Fusce quis eros sit amet enim laoreet dignissim. Sed auctor massa non arcu posuere, id sodales metus interdum.",
            stars: 4,
        },
        {
            icon: "/cargo/testimonials/pic3.png",
            title: isArabic ? "اسم العميل" : "Client Name",
            desc: isArabic
                ? "حلول مرنة وموثوقة لنقل شحناتك بأمان وفي الوقت المحدد."
                : "Praesent non enim sed velit malesuada consectetur id a justo. Fusce quis eros sit amet enim laoreet dignissim. Sed auctor massa non arcu posuere, id sodales metus interdum.",
            stars: 5,
        },
        {
            icon: "/cargo/testimonials/pic1.png",
            title: isArabic ? "اسم العميل" : "Client Name",
            desc: isArabic
                ? "خدمة عملاء متميزة واهتمام بكل تفاصيل شحنك."
                : "Praesent non enim sed velit malesuada consectetur id a justo. Fusce quis eros sit amet enim laoreet dignissim. Sed auctor massa non arcu posuere, id sodales metus interdum.",
            stars: 4,
        },
    ];

    const [startIndex, setStartIndex] = useState(0);
    const visibleCount = 4;

    const handlePrev = () => {
        setStartIndex((prev) =>
            prev === 0 ? testimonials.length - visibleCount : prev - 1,
        );
    };

    const handleNext = () => {
        setStartIndex((prev) =>
            prev + visibleCount >= testimonials.length ? 0 : prev + 1,
        );
    };

    const visibleTestimonials = testimonials.slice(
        startIndex,
        startIndex + visibleCount,
    );

    return (
        <section
            dir={isArabic ? "rtl" : "ltr"}
            className="w-full bg-[#f8fafc] py-24 font-stan"
        >
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                {/* Header Section */}
                <div className="mb-16 flex flex-col justify-between gap-8 md:flex-row md:items-end">
                    <div className="max-w-2xl">
                        <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-[#00B9EC]/10 px-4 py-1.5 w-fit">
                            <img
                                src="/cargo/herosection/right_arrow_color.svg"
                                alt="arrow"
                                className={`h-4 w-4 ${isArabic ? "rotate-180" : ""}`}
                            />
                            <span className="text-sm font-bold tracking-wider text-[#00B9EC] uppercase">
                                {isArabic ? "توصيات العملاء" : "TESTIMONIALS"}
                            </span>
                        </div>
                        <h2 className="whitespace-pre-line text-4xl font-extrabold leading-tight text-slate-900 sm:text-5xl lg:text-6xl">
                            {isArabic ? "ماذا يقول\nعملاؤنا" : "WHAT OUR\nCLIENTS SAY"}
                        </h2>
                    </div>

                    {/* Navigation Buttons */}
                    <div className="flex items-center gap-4">
                        <button 
                            onClick={handlePrev}
                            className="group flex h-14 w-14 items-center justify-center rounded-full border-2 border-slate-200 bg-white transition-all hover:border-[#00B9EC] hover:bg-[#00B9EC] shadow-sm"
                            aria-label="Previous Testimonial"
                        >
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 48 48"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className={`transition-transform group-hover:scale-110 group-hover:brightness-0 group-hover:invert ${isArabic ? "scale-x-[-1]" : ""}`}
                            >
                                <path
                                    d="M35.8301 6.00008L17.8301 24.0001L35.8301 42.0001L33.0001 44.8301L12.1701 24.0001L33.0001 3.17007L35.8301 6.00008Z"
                                    fill="#0F172A"
                                />
                            </svg>
                        </button>
                        <button 
                            onClick={handleNext}
                            className="group flex h-14 w-14 items-center justify-center rounded-full border-2 border-slate-200 bg-white transition-all hover:border-[#00B9EC] hover:bg-[#00B9EC] shadow-sm"
                            aria-label="Next Testimonial"
                        >
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 48 48"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className={`transition-transform group-hover:scale-110 group-hover:brightness-0 group-hover:invert ${isArabic ? "scale-x-[-1]" : ""}`}
                            >
                                <path
                                    d="M12.1699 41.9999L30.1699 23.9999L12.1699 5.99992L14.9999 3.16992L35.8299 23.9999L14.9999 44.8299L12.1699 41.9999Z"
                                    fill="#0F172A"
                                />
                            </svg>
                        </button>
                    </div>
                </div>

                {/* Cards Section */}
                <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                    {visibleTestimonials.map((card, i) => (
                        <div
                            key={i}
                            className="flex flex-col justify-between rounded-3xl bg-white p-8 shadow-sm transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:shadow-slate-200 border border-slate-100"
                        >
                            <div>
                                <img
                                    src={card.icon}
                                    alt="Client Photo"
                                    className="mb-6 h-16 w-16 rounded-full object-cover shadow-sm ring-4 ring-slate-50"
                                />
                                <p className="mb-6 text-base leading-relaxed text-slate-600 line-clamp-4">
                                    "{card.desc}"
                                </p>
                            </div>
                            
                            <div className="mt-auto border-t border-slate-100 pt-6">
                                <h3 className="mb-2 text-lg font-bold text-slate-900">
                                    {card.title}
                                </h3>
                                
                                <div className="flex items-center gap-1">
                                    {[...Array(5)].map((_, idx) => (
                                        <svg
                                            key={idx}
                                            className={`h-5 w-5 ${idx < card.stars ? "text-amber-400" : "text-slate-200"}`}
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                        </svg>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
